import Vue from 'vue'
import Router from 'vue-router'

import store from '../store'

// import AboutView from '../views/AboutView'
// import SettingsView from '../views/SettingsView'
// import InstrumentListView from '../views/InstrumentListView'
// import InstrumentView from '../views/InstrumentView'
// import CalibrationView from '../views/CalibrationView'
// import SampleListView from "../views/sample/SampleListView"
// import PlateListView from '../views/plate/PlateListView'
// import ProbePlexListView from '../views/probePlex/ProbePlexListView'
// import PlateView from '../views/plate/PlateView'
// import SearchView from '../views/SearchView'
//
// import SeqListView from '../views/seq/SeqListView'
// import SeqView from '../views/seq/SeqView'
//
// import LoginView from '../views/auth/LoginView'
// import NotFoundView from '../views/app/NotFoundView'

Vue.use(Router)

const requireAuthenticated = function (to, from, next) {

	store.dispatch('auth/initialize')
		.then(function () {
			if (!store.getters['auth/isAuthenticated']) {
				// нет аут
				next({path: 'login?from=' + to.path})
			} else {
				// аутентификация есть

				next()
			}
		})
}

const requireUnauthenticated = function (to, from, next) {
	store.dispatch('auth/initialize')
		.then(function () {
			if (store.getters['auth/isAuthenticated']) {
				next('/home')
			} else {
				next()
			}
		})
}

const redirectLogout = function (to, from, next) {
	store.dispatch('auth/logout')
		// .then(function () {
		// 	next('/login')
		// })
		.finally(function () {
			next('/login')
		})
}

export default new Router({
	saveScrollPosition: true,
	routes: [
		{
			path: '/',
			redirect: '/search',
		},
		{
			path: '/search',
			component: () => import('../views/SearchView'),
			beforeEnter: requireAuthenticated,
		},
		{
			path: '/instrument_list',
			component: () => import('../views/InstrumentListView'),
			beforeEnter: requireAuthenticated,
		},
		{
			path: '/calibrarion/:id',
			component: () => import('../views/CalibrationView'),
		},

		{
			path: '/sample_list',
			component: () => import('../views/sample/SampleListView'),
			beforeEnter: requireAuthenticated,
		},

		{
			path: '/plate_list',
			component: () => import('../views/plate/PlateListView'),
			beforeEnter: requireAuthenticated,
		},
		{
			path: '/plate/',
			component: () => import('../views/plate/PlateView'),
			beforeEnter: requireAuthenticated,
		},

		{
			path: '/seq_list',
			component: () => import('../views/seq/SeqListView'),
			beforeEnter: requireAuthenticated,
		},
		{
			path: '/seq/',
			component: () => import('../views/seq/SeqView'),
			beforeEnter: requireAuthenticated,
		},

		{
			path: '/probePlex_list',
			component: () => import('../views/probePlex/ProbePlexListView'),
			beforeEnter: requireAuthenticated,
		},
		{
			path: '/about',
			component: () => import('../views/AboutView'),
		},
		{
			path: '/settings',
			component: () => import('../views/SettingsView'),
		},
		{
			path: '/login',
			component: () => import('../views/auth/LoginView'),
			beforeEnter: requireUnauthenticated,
		},
		{
			path: '/logout',
			beforeEnter: redirectLogout,
		},
		{
			path: '*',
			component: () => import('../views/app/NotFoundView'),
		}
	]
})
